module.exports = {
  title: '龙翼客车运营管理平台',
  baseUrl: AppConfig.API_URL,
  socketServer: AppConfig.SOCKET_URL,
  //是否支持当天数据查询
  supportTodayDataQuery: true,
  routeStartTime: {}

}
